import React from 'react';
import Typography from 'housecall-ui/dist/DesignSystem/DataDisplay/Typography/Typography';
import Grid from 'housecall-ui/dist/DesignSystem/Layout/Grid/Grid';
import GoogleCalendarAppIcon from 'housecall-ui/dist/IconsAndImages/AppIcons/GoogleCalendarAppIcon';

import GoogleCalConnectDialog from '../Dialogs/GoogleCalConnectDialog';

const GoogleCalendarStrategy = {
  previewInfo: {
    name: 'Google cal',
    iconSvg: <GoogleCalendarAppIcon size="xlarge" />,
    newTab: true,
  },
  headerInfo: {
    name: 'Google calendar sync',
    category: '“Backup your Housecall Pro calendar',
    details: (
      <div>
        This App enables a one-way sync of jobs from your Housecall Pro account to your Google calendar. This is
        particularly useful if you keep multiple non-work related calendars on your Google calendar.
      </div>
    ),
    iconSvg: <GoogleCalendarAppIcon size="xlarge" />,
  },
  media: {
    wistiaLink: 'https://fast.wistia.net/embed/iframe/j6nlucbxml?autoPlay=false',
  },
  sellingPoints: {},
  planAvailability: {
    title: 'Housecall Pro Plan',
    description: (
      <Grid container spacing={8}>
        <Grid item xs={4}>
          <Typography align="left" variant="body1">
            Basic plan
          </Typography>
        </Grid>
        <Grid item xs={8}>
          <Typography align="right" variant="body1">
            Available
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography align="left" variant="body1">
            Essentials plan
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography align="right" variant="body1">
            Available
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography align="left" variant="body1">
            MAX plan
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography align="right" variant="body1">
            Available
          </Typography>
        </Grid>
      </Grid>
    ),
  },
  price: {
    hideCard: true,
  },
  supportContacts: [
    {
      type: 'Website',
      contact: (
        <a href="https://gsuite.google.com/products/calendar/" target="_blank" rel="noreferrer">
          Google calendar
        </a>
      ),
    },
  ],
  dialog: <GoogleCalConnectDialog />,
};

export default GoogleCalendarStrategy;
